"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

var mobile = {
  '& $logo': {
    marginLeft: 12
  },
  '& $titleWrapper $logo': {
    display: 'none'
  },
  '& $title': {
    display: 'block'
  }
};

exports.styles = function (theme) {
  return __assign({
    portalHeader: {
      height: 56,
      minWidth: 320,
      backgroundColor: theme.colorPrimary.normal
    },
    logo: {
      lineHeight: '56px',
      height: '56px',
      marginLeft: '84px'
    },
    logoImg: {
      verticalAlign: 'middle',
      border: 'none'
    },
    wrapper: {
      margin: 'auto',
      maxWidth: 1572
    },
    titleWrapper: {},
    title: {
      display: 'none',
      textAlign: 'center',
      lineHeight: '52px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 'normal',
      fontSize: 20,
      color: '#fff',
      margin: 0
    }
  }, mobileStylesHelper_1.default(mobile));
};